/* HYDE STORE — Trove PDP V1 commerce, measurement and governed fit. */
(function () {
  if (window.__hydeTrovePdpV1Init) return;
  window.__hydeTrovePdpV1Init = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function rootPath() {
    return window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
  }

  function emit(root, action, detail) {
    var payload = Object.assign(
      {
        event: 'hyde_trove_pdp_interaction',
        action: action,
        product_model: root.getAttribute('data-hyde-model') || '',
        knowledge_density: root.getAttribute('data-hyde-density') || ''
      },
      detail || {}
    );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try {
        window.Shopify.analytics.publish(
          'hyde_trove_pdp_interaction',
          payload
        );
      } catch (_analyticsError) {
        // Measurement must never interrupt selection or checkout behavior.
      }
    }
    document.dispatchEvent(
      new CustomEvent('hyde:trove-pdp', { bubbles: true, detail: payload })
    );
  }

  function updateCartCount(added) {
    return fetch(rootPath() + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.ok ? response.json() : Promise.reject();
      })
      .then(function (cart) {
        if (added && window.HydeNetCart) window.HydeNetCart.added(added, cart);
        document
          .querySelectorAll('.cart-count-bubble')
          .forEach(function (bubble) {
            bubble.innerHTML =
              '<span aria-hidden="true">' +
              cart.item_count +
              '</span><span class="visually-hidden">' +
              cart.item_count +
              ' items</span>';
            bubble.hidden = cart.item_count < 1;
          });
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cart }
          })
        );
      });
  }

  function initCommerce(root) {
    var tiers = Array.prototype.slice.call(
      root.querySelectorAll('[data-hyde-tier]')
    );
    var price = root.querySelector('[data-hyde-price]');
    var stickyPrice = root.querySelector('[data-hyde-sticky-price]');
    var note = root.querySelector('[data-hyde-price-note]');
    var save = root.querySelector('[data-hyde-price-save]');
    var atc = root.querySelector('[data-hyde-atc]');
    var sticky = root.querySelector('[data-hyde-sticky-atc]');
    var form = root.querySelector('#hyde-trove-atc-form');
    var variantInput = root.querySelector('[data-hyde-variant-input]');
    var quantityInput = root.querySelector('[data-hyde-quantity-input]');
    var status = root.querySelector('[data-hyde-cart-status]');
    var shippingNote = root.querySelector('[data-hyde-shipping-note]');
    if (!form || !atc || !variantInput || !quantityInput) return;

    function updateSelectedShippingNote(button, quantity) {
      if (!shippingNote) return;
      var unitCents = parseInt(button.getAttribute('data-unit-cents') || '', 10);
      if (!Number.isInteger(unitCents) || unitCents < 0) return;
      var selectedSubtotalCents = unitCents * quantity;
      var selectedSubtotal = (selectedSubtotalCents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      var freightCopy = shippingNote.getAttribute('data-freight-copy');
      if (freightCopy) {
        shippingNote.textContent = 'Selected subtotal: ' + selectedSubtotal + '. ' + freightCopy;
        return;
      }
      shippingNote.textContent =
        'Selected subtotal: ' + selectedSubtotal +
        '. Standard US shipping is $9.99 below $15, $7.99 from $15 to below $49, and free at $49 after discounts. ' +
        'Freight items are excluded; other rates are shown at checkout.';
    }

    tiers.forEach(function (button) {
      button.setAttribute(
        'aria-pressed',
        button.classList.contains('is-selected') ? 'true' : 'false'
      );
      button.addEventListener('click', function () {
        tiers.forEach(function (other) {
          other.classList.remove('is-selected');
          other.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        if (price) price.textContent = button.getAttribute('data-unit-price');
        if (stickyPrice) stickyPrice.textContent = button.getAttribute('data-unit-price');
        if (note) note.textContent = button.getAttribute('data-price-note');
        if (save) save.textContent = button.getAttribute('data-save');
        variantInput.value = button.getAttribute('data-variant-id');
        quantityInput.value = button.getAttribute('data-quantity') || '1';
        var available = button.getAttribute('data-available') !== 'false';
        var selectedQuantity = parseInt(quantityInput.value || '1', 10);
        updateSelectedShippingNote(button, selectedQuantity);
        atc.disabled = !available;
        atc.textContent = available
          ? button.getAttribute('data-add-label')
          : 'CURRENTLY UNAVAILABLE';
        if (sticky) {
          sticky.disabled = !available;
          sticky.textContent = available
            ? selectedQuantity === 1
              ? 'ADD TO CART'
              : 'ADD QTY ' + selectedQuantity
            : 'UNAVAILABLE';
        }
        emit(root, 'select_public_quantity_tier', {
          quantity: selectedQuantity,
          unit_price: button.getAttribute('data-unit-price'),
          save_label: button.getAttribute('data-save')
        });
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var original = atc.textContent;
      var selectedQuantity = parseInt(quantityInput.value || '1', 10);
      atc.disabled = true;
      if (sticky) sticky.disabled = true;
      if (status) status.textContent = 'Adding selected quantity to cart.';

      fetch(rootPath() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: parseInt(variantInput.value, 10),
          quantity: selectedQuantity
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function (line) {
          atc.textContent = '✓ ADDED — IN YOUR CART';
          if (status) status.textContent = line.quantity + ' added to cart.';
          emit(root, 'add_to_cart', {
            variant_id: variantInput.value,
            quantity: selectedQuantity
          });
          return updateCartCount([{id: variantInput.value, key: line.key, quantity: selectedQuantity}])
            .catch(function () { /* The add succeeded; never submit the same quantity again. */ });
        })
        .then(function () {
          document.dispatchEvent(
            new CustomEvent('hyde:cart:added', { bubbles: true })
          );
          window.setTimeout(function () {
            atc.textContent = original;
            atc.disabled = false;
            if (sticky) sticky.disabled = false;
          }, 2200);
        })
        .catch(function () {
          atc.disabled = false;
          if (sticky) sticky.disabled = false;
          if (status) {
            status.textContent =
              'Cart update failed. Submitting through Shopify.';
          }
          HTMLFormElement.prototype.submit.call(form);
        });
    });
    if (sticky) {
      sticky.addEventListener('click', function () {
        form.requestSubmit();
      });
    }
  }

  function initCounter(root) {
    var counter = root.querySelector('[data-hyde-counter]');
    var configElement = document.getElementById('hyde-fit-config');
    if (!counter || !configElement) return;
    var config;
    try {
      config = JSON.parse(configElement.textContent);
    } catch (_error) {
      return;
    }
    if (
      !config ||
      config.engine !== 'material_geometry_reach_action_v1'
    ) {
      return;
    }

    var state = {
      material: null,
      geometry: null,
      reach: null,
      action: null
    };
    var questions = counter.querySelector('[data-hyde-questions]');
    var gates = {
      material: function () {
        return true;
      },
      geometry: function () {
        return state.material === 'compound';
      },
      reach: function () {
        return (
          state.material === 'compound' &&
          ['apex', 'tight', 'slot'].indexOf(state.geometry) !== -1
        );
      },
      action: function () {
        return (
          state.material === 'compound' &&
          state.geometry &&
          ['open', 'flat'].indexOf(state.geometry) === -1 &&
          state.reach === 'palm'
        );
      }
    };
    var questionNumber = {
      material: 'Q1',
      geometry: 'Q2',
      reach: 'Q3',
      action: 'Q4'
    };

    function resolve() {
      var redirect = config.redirects;
      if (!state.material) return { id: 'pending' };
      if (state.material === 'mortar') {
        return { id: 'redirect', redirect: redirect.mortar };
      }
      if (state.material === 'putty') {
        return { id: 'redirect', redirect: redirect.putty };
      }
      if (state.action === 'scrape') {
        return { id: 'redirect', redirect: redirect.scrape };
      }
      if (!state.geometry) return { id: 'pending' };
      if (state.geometry === 'open') {
        return { id: 'redirect', redirect: redirect.open };
      }
      if (state.geometry === 'flat') {
        return { id: 'redirect', redirect: redirect.flat };
      }
      if (!state.reach) return { id: 'pending' };
      if (state.reach === 'deep') return { id: 'sibling' };
      if (!state.action) return { id: 'pending' };
      return { id: 'fit' };
    }

    function nextQuestion() {
      if (!state.material) return 'Q1';
      if (!state.geometry) return 'Q2';
      if (gates.reach() && !state.reach) return 'Q3';
      return 'Q4';
    }

    function setText(selector, value) {
      var node = counter.querySelector(selector);
      if (node) node.textContent = value || '';
    }

    function choose(key, value) {
      state[key] = value;
      if (key === 'material') {
        state.geometry = null;
        state.reach = null;
        state.action = null;
      }
      if (key === 'geometry') {
        state.reach = null;
        state.action = null;
      }
      if (key === 'reach') state.action = null;
      emit(root, 'counter_answer', { question: key, answer: value });
      render();
      var groups = questions.querySelectorAll('.hyde-qgroup');
      var next = groups.length
        ? groups[groups.length - 1].querySelector('.hyde-qopt')
        : null;
      if (next) next.focus({ preventScroll: true });
    }

    function renderQuestions(verdict) {
      questions.innerHTML = '';
      var next = verdict.id === 'pending' ? nextQuestion() : '';
      config.questions.forEach(function (question) {
        if (!gates[question.key]()) return;
        var group = document.createElement('fieldset');
        group.className = 'hyde-qgroup';
        var legend = document.createElement('legend');
        legend.className = 'hyde-qlabel';
        legend.textContent = question.label;
        if (question.note) {
          var note = document.createElement('em');
          note.textContent = ' — ' + question.note;
          legend.appendChild(note);
        }
        var turn = document.createElement('span');
        turn.className =
          'hyde-turn' +
          (next === questionNumber[question.key] ? ' is-on' : '');
        turn.textContent = ' → YOUR TURN';
        legend.appendChild(turn);
        var row = document.createElement('div');
        row.className = 'hyde-qrow';
        question.options.forEach(function (option) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className =
            'hyde-qopt' +
            (state[question.key] === option.v ? ' is-selected' : '');
          button.setAttribute(
            'aria-pressed',
            state[question.key] === option.v ? 'true' : 'false'
          );
          var strong = document.createElement('b');
          strong.textContent = option.label;
          var sub = document.createElement('span');
          sub.textContent = ' — ' + option.sub;
          button.appendChild(strong);
          button.appendChild(sub);
          button.addEventListener('click', function () {
            choose(question.key, option.v);
          });
          row.appendChild(button);
        });
        group.appendChild(legend);
        group.appendChild(row);
        questions.appendChild(group);
      });
    }

    function render() {
      var verdict = resolve();
      renderQuestions(verdict);
      counter
        .querySelectorAll('[data-hyde-verdict]')
        .forEach(function (panel) {
          panel.hidden =
            panel.getAttribute('data-hyde-verdict') !== verdict.id;
        });
      var answered = ['material', 'geometry', 'reach', 'action'].filter(
        function (key) {
          return state[key];
        }
      ).length;
      setText(
        '[data-hyde-progress]',
        verdict.id === 'pending'
          ? 'WAITING ON YOU — ANSWER ' + nextQuestion()
          : 'RESOLVED IN ' +
              answered +
              (answered === 1 ? ' ANSWER' : ' ANSWERS')
      );
      if (verdict.id === 'pending') {
        setText('[data-hyde-nextq]', nextQuestion());
      }
      if (verdict.id === 'fit') {
        setText(
          '[data-hyde-fit-why]',
          config.fit.reasons[state.geometry]
        );
        setText('[data-hyde-fit-boundary]', config.fit.boundary);
      }
      if (verdict.id === 'sibling') {
        setText('[data-hyde-sib-why]', config.sibling.why);
      }
      if (verdict.id === 'redirect') {
        setText(
          '[data-hyde-redirect-head]',
          verdict.redirect.head
        );
        setText(
          '[data-hyde-redirect-why]',
          verdict.redirect.why
        );
        setText(
          '[data-hyde-redirect-tool]',
          verdict.redirect.tool
        );
        setText(
          '[data-hyde-redirect-models]',
          verdict.redirect.models
        );
        var redirectLink = counter.querySelector(
          '[data-hyde-redirect-url]'
        );
        if (redirectLink) redirectLink.href = verdict.redirect.url;
      }

      var chip = root.querySelector('[data-hyde-fitchip]');
      var chipLabel = root.querySelector('[data-hyde-fitchip-label]');
      if (chip && chipLabel) {
        chip.classList.remove('is-fit', 'is-sibling', 'is-redirect');
        if (verdict.id === 'fit') {
          chip.classList.add('is-fit');
          chipLabel.textContent =
            '✓ RATED FOR YOUR JOB — ' +
            (config.fit.chipGeo[state.geometry] || '');
        } else if (verdict.id === 'sibling') {
          chip.classList.add('is-sibling');
          chipLabel.textContent = config.sibling.chip;
        } else if (verdict.id === 'redirect') {
          chip.classList.add('is-redirect');
          chipLabel.textContent =
            'A DIFFERENT TOOL FITS BETTER — SEE THE COUNTER';
        } else {
          chipLabel.textContent = 'IS THIS RIGHT FOR MY JOB?';
        }
      }

      var helper = root.querySelector('[data-hyde-fab]');
      var helperStatus = root.querySelector('[data-hyde-fab-status]');
      if (helper && helperStatus) {
        helper.classList.remove('is-fit', 'is-sibling', 'is-redirect');
        if (verdict.id === 'fit') {
          helper.classList.add('is-fit');
          helperStatus.textContent = '✓ RATED FOR YOUR JOB';
        } else if (verdict.id === 'sibling') {
          helper.classList.add('is-sibling');
          helperStatus.textContent = config.sibling.fab;
        } else if (verdict.id === 'redirect') {
          helper.classList.add('is-redirect');
          helperStatus.textContent =
            'TIP — A DIFFERENT TOOL FITS BETTER';
        } else {
          helperStatus.textContent = answered
            ? 'WAITING ON YOU — ANSWER ' + nextQuestion()
            : 'DOES THIS FIT YOUR JOB? — 30-SEC CHECK';
        }
      }

      if (verdict.id !== 'pending') {
        emit(root, 'counter_verdict', {
          verdict: verdict.id,
          material: state.material,
          geometry: state.geometry,
          reach: state.reach,
          action_choice: state.action,
          redirect_url:
            verdict.redirect && verdict.redirect.url
              ? verdict.redirect.url
              : ''
        });
      }
    }

    var reset = counter.querySelector('[data-hyde-reset]');
    if (reset) {
      reset.addEventListener('click', function () {
        state.material = null;
        state.geometry = null;
        state.reach = null;
        state.action = null;
        emit(root, 'counter_reset');
        render();
        var first = questions.querySelector('.hyde-qopt');
        if (first) first.focus();
      });
    }
    var verdictAtc = counter.querySelector('[data-hyde-verdict-atc]');
    if (verdictAtc) {
      verdictAtc.addEventListener('click', function () {
        var form = root.querySelector('#hyde-trove-atc-form');
        if (form) form.requestSubmit();
      });
    }
    render();
  }

  function initNavigation(root) {
    root.querySelectorAll('[data-scroll-to]').forEach(function (button) {
      button.addEventListener('click', function () {
        var target = root.querySelector(button.getAttribute('data-scroll-to'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    root.querySelectorAll('[data-hyde-action]').forEach(function (link) {
      link.addEventListener('click', function () {
        emit(root, link.getAttribute('data-hyde-action'), {
          target: link.getAttribute('href') || ''
        });
      });
    });
  }

  ready(function () {
    document
      .querySelectorAll('[data-hyde-pdp="trove-v1"]')
      .forEach(function (root) {
        initCommerce(root);
        initCounter(root);
        initNavigation(root);
      });
  });
})();
